/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { useSelector } from 'react-redux';
import FormContents from 'components/atoms/Form/FormContents';
import FormField from 'components/atoms/Form/FormField';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import BodyText from 'components/atoms/BodyText';
import PrimaryButton from 'components/atoms/Button';
import DatePickerForm from 'components/molecules/DatePickerForm';
import RadioSelectForm from 'components/molecules/RadioSelectForm';
import FileSelectButton from 'components/molecules/FileSelectButton';
import BlockUI from 'components/molecules/BlockUi';
import ConfirmModal from 'components/organismos/ConfirmModal';
import { utilityColor } from 'components/styles';
import { Store } from 'modules/store';
import useTanomuCsvImport from './hooks';

const styles = {
  dateField: css({ width: '200px' }),
};

const TanomuCsvImportLayout: React.FC = () => {
  const {
    importDate,
    setImportDate,
    existData,
    setExistData,
    uploadFile,
    setUploadFile,
    inputValue,
    errors,
    confirmModalOpen,
    closeConfirmModal,
    handleSubmit,
    onSubmit,
    blocking,
    optionsExistData,
  } = useTanomuCsvImport();

  const roleScreen = useSelector((state: Store) => state.auth.roleScreen);

  return (
    <div>
      <BlockUI blocking={blocking}>
        <FormContents>
          <FormField>
            <div css={styles.dateField}>
              <DatePickerForm
                label="取込日"
                date={importDate}
                required={true}
                changeDate={(date: Date) => setImportDate(date)}
              />
            </div>
          </FormField>

          <FormField>
            <RadioSelectForm
              label="取込方式"
              items={optionsExistData}
              name="existData"
              value={String(existData)}
              setValue={(e: any) => setExistData(Number(e.target.value))}
            />
          </FormField>

          <BodyText color={utilityColor.error} size="md">
            ※CSVファイルの１行目（ヘッダー行）はインポートされません。
          </BodyText>

          <FormField>
            <FileSelectButton
              text="CSVファイルをドラッグ＆ドロップ  または  クリックしてファイルを選択してください"
              ghost={true}
              setFile={setUploadFile}
              value={inputValue}
              accept=".csv"
            />
          </FormField>

          {(uploadFile || errors) && (
            <FormField displayBlock={true}>
              <div>{uploadFile?.name}</div>
              {errors && errors.map((error) => (
                <div key={error}>
                  <BodyText color={utilityColor.error}>{error}</BodyText>
                </div>
              ))}
            </FormField>
          )}

          <FormSubmitArea>
            {roleScreen && roleScreen.importFlag === 1 && (
              <PrimaryButton
                text="インポート"
                onClick={handleSubmit}
                disabled={!uploadFile || !importDate}
              />
            )}
          </FormSubmitArea>
        </FormContents>
      </BlockUI>

      <ConfirmModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        title="確認メッセージ"
        onSubmit={onSubmit}
        content="ファイルをアップロードします。よろしいですか？"
        items={[]}
      />
    </div>
  );
};

export default TanomuCsvImportLayout;
